<!-- Layout 1: Text Left, Image Right -->
<div class="hero-container" *ngIf="data?.title || data?.description || data?.buttonText">
  <div class="hero-content">
    <div class="hero-text-content">
      <h1 class="hero-title"
          *ngIf="data?.title"
          [style.color]="headingColor || '#FFFFFF'"
          [style.font-family]="headingFont || 'Plus Jakarta Sans'"
          [ngStyle]="titleStyles">{{ data?.title }}</h1>
      <p class="hero-description"
         *ngIf="data?.description"
         [style.color]="paragraphColor || '#FFFFFF'"
         [style.font-family]="bodyFont || 'Inter'">
        {{ data?.description }}
      </p>
    </div>
    <button class="hero-btn" 
            *ngIf="data?.buttonText"
            [style.background-color]="primaryColor || '#00435D'"
            [style.color]="'#FFFFFF'"
            [style.font-family]="headingFont || 'Plus Jakarta Sans'"
            (click)="onButtonClick(data?.buttonLink, $event)">
      <span class="button-text">{{ data?.buttonText }}</span>
      <svg class="button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  <div class="hero-illustration" *ngIf="getImageSrc()">
    <img [src]="getImageSrc() || ''" 
         [alt]="getImageAlt() || ''"
         [ngStyle]="getImageStyles()"
         class="car-illustration">
  </div>
</div>

